import { CALLURL, COREURL } from "../../../constants/api_constants";

import { ApiServices } from "../../../services/api_services";
import { createAsyncThunk } from "@reduxjs/toolkit";
import store from "../../redux-store/root_store";
import { userList } from "../../../constants/interface/users";
import { CallServices, CoreServices, EmailServices } from "../../../base/service/apiServices";
import { config } from "../../../base/constant";
import { GetItemFromStorage, SetItemInStorage } from "../../../custom_hooks/useStorage";

export const getAllContactList = createAsyncThunk("contacts/get_customer_conatct", async () => {
  return ApiServices.get(COREURL, `/get_customer_conatct/null`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

export const getContactDetailsforAgent = createAsyncThunk("contacts/get_customer_contact_det", async (coid: any) => {
  return ApiServices.get(COREURL, `/get_customer_contact_phoneNumber/${coid}`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

export const updateContactinSession = createAsyncThunk("session/updateSessioninContact", async (data: any) => {
  return ApiServices.put(config().CALLSERVICE_URL, `/update_called_person_details/${data.sessionId}`, { calledPersonDetails: data.calledPersonDetails })
    .then((response: any) => {
      return response;
    })
    .catch((error: any) => error);
});

export const getContactDetailsWhilegettingCall = async (coid: any) => {
  let _coid: any = coid;
  if (coid) {
    SetItemInStorage("coid", coid);
  } else {
    _coid = GetItemFromStorage("coid");
    if (_coid && _coid !== "") _coid = parseInt(_coid);
  }
  return new Promise(async (resolve, reject) => {
    return ApiServices.get(COREURL, `/get_customer_contact_phoneNumber/${_coid}`, 30000)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};

export const getContactDetails = async (coid: any, channelType: any) => {
  let data = {
    "chennalType": channelType,
    "channelValue": coid
  }
  return new Promise(async (resolve, reject) => {
    return ApiServices.post(COREURL, `/get_customer_contact_channel`, data, 30000)
      .then((response: any) => {
        resolve(response);
      })
      .catch((error: any) => reject(error));
  });
};



export const getContactDetailsWhilegettingChat = async (coid: any) => {
  return new Promise(async (resolve, reject) => {
    return ApiServices.get(COREURL, `/get_customer_conatct_details/${coid}`, 30000)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};

////callservice/v1/get_conversation_list/{sessionId}
export const getChatWhilegettingCall = async (sessionId: any) => {
  return new Promise(async (resolve, reject) => {
    return ApiServices.get(config().CALLSERVICE_URL, `/get_customer_history/${sessionId}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};

export const getQueueDetail = async (sessionId: any) => {
  return new Promise(async (resolve, reject) => {
    return ApiServices.get(COREURL, `/get_session_details/${sessionId}`, 30000)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};

export const getCallSessionById = async (sessionId: any) => {
  return new Promise(async (resolve, reject) => {
    return ApiServices.get(config().CALLSERVICE_URL, `/get_callSessionId/${sessionId}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};

export const getSessionById = async (sessionId: any, channelType: any) => {
  return new Promise(async (resolve, reject) => {
    return CoreServices.post({ channelType, sessionId }, `/get_email_history_details`)
      .then((response: any) => {
        resolve(response);
      })
      .catch((error: any) => reject(error));
  });
};

export const getNecessaryDetails = createAsyncThunk("data/contact_queue", async (data: any) => {
  let [contact, sessionDetail]: any = await Promise.all([getContactDetailsWhilegettingChat(data.contact ?? 0), getQueueDetail(data.sessionId)]);
  return { contact, sessionDetail };
});

export const getCallNecessaryDetails = createAsyncThunk("data/contact_queue", async (data: any) => {
  let [contact, sessionDetail]: any = await Promise.all([getContactDetails(data.contact, 'Call'), getQueueDetail(data.sessionId)]);
  return { contact, sessionDetail };
});

// export const getNecessaryDetailswithsession = createAsyncThunk("data/contact_queue", async (data: any) => {
//   let [contact, sessionDetail]: any = await Promise.all([
//     (data?.channelType === 'Email' || data?.channelType === 'Sms' || data?.channelType === 'Whatsapp' || data?.channelType === 'Facebook' || data?.channelType === 'Instagram') ? getContactDetails(data.contact, data?.channelType) :data?.channelType === 'Call' ? getContactDetailsWhilegettingCall(data.contact)  : getContactDetailsWhilegettingChat(data.contact),
//     (data?.channelType === 'Email' || data?.channelType === 'Sms' || data?.channelType === 'Whatsapp' || data?.channelType === 'Facebook' || data?.channelType === 'Instagram') ?
//       getSessionById(data.sessionId, data?.channelType)
//       : (data?.channelType === 'Call' || data?.channelType === 'Chat') ? getSessionById(data.sessionId, data?.channelType) :
//         getChatSessionById(data.sessionId),
//     //getChatWhilegettingCall(data.sessionId),
//   ]);
//   /*  let [contact, sessionDetail]: any = await Promise.all([
//      getContactDetailsWhilegettingCall(data.contact),
//      (data?.channelType === 'Email' || data?.channelType=== 'Sms' || data?.channelType === 'Whatsapp')?
//      getSessionById(data.sessionId,data?.channelType)
//      :
//      getChatSessionById(data.sessionId),
//      //getChatWhilegettingCall(data.sessionId),
//  ]); */
//   console.log('ssss', { contact, sessionDetail })
//   return { contact, sessionDetail };
// });

export const getNecessaryDetailswithsession = createAsyncThunk("data/contact_queue", async (data: any) => {
  if (data.channelType === 'Voicemail') {
    data.channelType = 'Call'
  }
  let [contact, sessionDetail]: any = await Promise.all([
    (data?.channelType === 'Email' || data?.channelType === 'Sms' || data?.channelType === 'Whatsapp' || data?.channelType === 'Facebook' || data?.channelType === 'Instagram') ? getContactDetails(data.contact, data?.channelType) :
      data?.channelType === 'Chat' ? getContactDetailsWhilegettingChat(data.contact)
        : getContactDetails(data.contact, "Call"),
    (data?.channelType === 'Email' || data?.channelType === 'Sms' || data?.channelType === 'Whatsapp' || data?.channelType === 'Facebook' || data?.channelType === 'Instagram') ?
      getSessionById(data.sessionId, data?.channelType)
      : (data?.channelType === 'Call' || data?.channelType === 'Chat') ? getSessionById(data.sessionId, data?.channelType) :
        getCallSessionById(data.sessionId),
  ]);
  return { contact, sessionDetail };
});

export const showDetials = async (data: any) => {
  return await getSessionById(data.sessionId, data?.channelType)
};


export const getNecessaryDetailswithmessage = createAsyncThunk("data/contact_queue", async (data: any) => {
  let [contact, sessionDetail, messageList]: any = await Promise.all([
    getContactDetails(data.contact, 'Call'),
    getCallSessionById(data.sessionId),
    getChatWhilegettingCall(data.sessionId),
  ]);
  return { contact, sessionDetail, messageList };
});

export const getTagsForCustomers = createAsyncThunk("agnet/getTagsForCustomers", async () => {
  return ApiServices.get(COREURL, "/get_customer_tag")
    .then((response) => response)
    .catch((error) => error);
});

export const getDispositionForCustomers = createAsyncThunk("agnet/getDispositionForCustomers", async () => {
  return ApiServices.get(config().CALLSERVICE_URL, "/get_disposition_status")
    .then((response) => response)
    .catch((error) => error);
});
export const getQueueeList = createAsyncThunk("queue/get_queue_list", async () => {
  return ApiServices.get(COREURL, "/get_queue_list")
    .then((response) => response)
    .catch((error) => error);
});

export const searchQueueList = createAsyncThunk("queue/get_queue_list?name=", async (queue: any) => {
  return ApiServices.get(COREURL, `/get_queue_list?name=${queue}`)
    .then((response) => response)
    .catch((error) => error);
});

export const getMessageFromSessionID = createAsyncThunk("chat/get_message_list", async (sessionId: any) => {
  return ApiServices.get(config().CALLSERVICE_URL, `/get_conversation_list/${sessionId}`)
    .then((response) => response)
    .catch((error) => error);
});

export const getSessionList = createAsyncThunk("session/sessionList", async () => {
  return ApiServices.get(config().CALLSERVICE_URL, "/get_call_session")
    .then((response: any) => response)
    .catch((error: any) => error);
});

// export const getUser = (ext: any) => {
//   const userListData: userList = store.getState().userList;

//   let index: any = userListData.users.findIndex((item: any) => item.ext === ext);
//   return userListData.users[index];
// };
export const getDndByCustomerNum = async (dialedNumber:any) => {
  return new Promise(async (resolve, reject) => {
    return CallServices.post({ customerNumber:dialedNumber}, `/get_customer_dnd_info`)
      .then((response: any) => {
        resolve(response);
      })
      .catch((error: any) => reject(error));
  });
};